import React, { lazy, useContext, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { TableContext } from '../contexts/tableContext';
import PageLoader from '../components/PageLoader/PageLoader';
import styles from '../components/CancelTicket/CancelTicket.module.scss';

// const Header = lazy(() => import('../components/Header/Header'));
// const Footer = lazy(() => import('../components/Footer/DashFooter'));
const EventsSidebar = lazy(() => import('../components/EventsSidebar/EventsSidebar'));

export default function EventsLayout() {
  const { bodyStyleNew, dashboardStyle } = useContext(TableContext);

  return (
    <>
      <EventsSidebar />
      <div className={styles[bodyStyleNew]}>
        <div className={styles[dashboardStyle]}>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </>
  );
}
